<template>
<div>
    <div v-if="checkBrowserSupport" v-for="(printerInfo,index) in allPrinterInfo" :key="printerInfo.serialNumber || index" class="container-printer">
        <div class="col-1">
            <div class="specs">
                <div class="image-status">
                    <button @click="updatePrinter(printerInfo)">
                        <img v-if="printerInfo.connected && printerInfo.tagType" src="../assets/img/PrinterConnected.svg" alt="Printer Enabled">
                        <img v-else-if="!printerInfo.tagType && printerInfo.connected" src="../assets/img/PrinterWarning.svg" alt="Printer Warning">
                        <img v-else src="../assets/img/PrinterUnconnected.svg" alt="Printer Disconnected">
                    </button>
                </div>
                <div class="text-specs">
                    <h3>{{ printerInfo.name || printerInfo.productName ? getPrinterInfoName(printerInfo) : 'No Device'}}</h3>
                    <!-- Overwrite logbook styles -->
                    <p id="special-p" class="name">{{ printerInfo.productName ? 'Model: ' + printerInfo.productName.slice(3,16): 'Model: ------------ '}}</p>
                    <p id="special-p" class="name">{{ printerInfo.serialNumber ? 'SN: ' + printerInfo.serialNumber: 'SN: --------------- '}}</p>
                    <p id="special-p" class="name">{{ printerInfo.tagType ? 'Tag Type: ' + printerInfo.tagType : 'Tag Type: -------- '}}</p>
                </div>
            </div>
        </div>
        <div class="col-2"> 
            <div class="options-row">
                <template v-if="printerInfo.connected">
                    <button class="action" @click="handleConfigureModal(printerInfo)">Configure</button>
                    <button class="action" @click="handleStatusModal(printerInfo)">Info</button>
                </template>
                <button v-else class="action" @click="updatePrinter(printerInfo)">Connect</button>
                <!-- Configure Modal -->
                <div v-if="printerInfo.showConfigureModal" class="modal">
                    <div class="inner"> 
                        <h2>Printer Configuration</h2>
                        <div class="content">
                            <div>
                                <label for="tag">Tag Type (required)</label>
                                <select
                                    @change="validateTagType(printerInfo)"
                                    id="tag" v-model="printerInfo.tagType">
                                    <option value="">Select a tag type</option>
                                    <option value="shelf">Shelf</option>
                                    <option value="shelf_wide">Shelf Wide</option>
                                    <option value="sequence_small">Sequence Small</option>
                                    <option value="sequence">Sequence Large</option>
                                    <option value="box">Box</option>
                                    <option value="gun">Gun</option>
                                    <option value="large">Large (Box, Sequence, Gun)</option>
                                    <option value="zebra_4x6">ZD421 4x6</option>
                                </select>
                            </div>
                            <label class="styled-test" for="printer-name">Printer Name (optional)</label>
                            <input 
                                type="text" 
                                :id="'printer-name-' + printerInfo.serialNumber"
                                v-model="printerInfo.name" 
                                maxlength="13" 
                            >
                            <div class="calibrate-buttons">
                                <div class="container-info">
                                    <button class="action" @click="calibratePrinter(printerInfo)" :disabled="!printerInfo.tagType">Calibrate</button>
                                    <!-- Tool tip -->
                                        <div class="tool-tip">
                                        <i class="fas fa-info-circle control" @mouseover="showToolTipContent = true" @mouseleave="showToolTipContent = false"></i>
                                        <div v-if="showToolTipContent" class="tool-tip-content" :class="{'tool-tip-right': duplicateTagTypes}">
                                            {{"A command will be sent to the printer to calibrate the selected tag size. During the calibration process, the printer will output several blank tags."}}
                                        </div>
                                    </div>
                                </div>
                                <label v-if="duplicateTagTypes" class="radio">
                                <input type="radio" v-model="selectedDuplicatePrinter" :value="printerInfo.serialNumber">
                                <span><i class="fas fa-check-circle"></i>Default Printer</span>
                            </label>
                            </div>
                            <div class="config-message">{{ generalMessage || errorMessage}}</div>
                        </div>
                        <div class="controls">
                            <button class="button spaced action" @click="savePrinter(printerInfo)" :disabled="!printerInfo.tagType || badPrinterName(printerInfo) || !printerInfo.connected">Save</button>
                            <button class="button cancel spaced"  
                                @click="handleConfigureModal(printerInfo)">
                                Back
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Info Modal -->
                <div v-if="printerInfo.showInfoModal" class="modal">
                    <div class="inner">
                        <h2>Printer Info</h2>
                            <div v-if="printerInfo.connected" class="content printer-info">
                                <div class="info-options-col">
                                    <button 
                                        v-if="printerInfo.connected" 
                                        class="action" 
                                        @click="handleInfoClick(printerInfo, 'status')" 
                                        :disabled="isLoading"
                                    >
                                    Diagnostic
                                    </button>
                                    <button 
                                        v-if="printerInfo.connected" 
                                        class="action" 
                                        @click="handleInfoClick(printerInfo, 'config')" 
                                        :disabled="isLoading"
                                    >
                                    Settings 
                                    </button>

                                    <button 
                                        v-if="printerInfo.connected" 
                                        class="action" 
                                        @click="handleInfoClick(printerInfo, 'clear')" 
                                        :disabled="isLoading"
                                    >
                                    Clear Buffer
                                    </button>
                                    <!-- Add empty space -->
                                    <div></div>
                                </div>
                                <div class="info-options-col-2">
                                    <h4>Printer Output</h4>
                                    <label for="diagnostic-output"></label>
                                    <textarea id="diagnostic-output" readonly>
                                    {{ printerInfo.message || '' }}
                                    </textarea>
                                
                                    <div class="info-options-row">
                                        <button 
                                        v-if="printerInfo.connected" 
                                        class="action" 
                                        @click="handleInfoClick(printerInfo, 'info')" 
                                        :disabled="isLoading"
                                        >
                                        Firmware 
                                        </button>
                                        <button 
                                        v-if="printerInfo.connected" 
                                        class="action" 
                                        @click="handleInfoClick(printerInfo, 'network')" 
                                        :disabled="isLoading"
                                        >
                                        IP Address
                                        </button>
                                    </div>
                                </div>
                            </div>
                        <div class="controls">
                            <div class="button cancel spaced" @click="handleStatusModal(printerInfo)">Back</div>
                        </div>
                    </div>
                </div>
                <button class="action" @click="resetPrinter(printerInfo)">Reset</button>
            </div> 
            <div class="status-message">
                    <p id="special-p">{{ printerInfo.message && !printerInfo.showConfigureModal && !printerInfo.showInfoModal ? printerInfo.message : '' }}</p>
            </div> 
        </div> 
        <div class="col-3">
            <button id="delete" class="action" @click="disconnectPrinter(index)">x</button>
            <button class="action save" @click="savePrinter(printerInfo)" :disabled="!printerInfo || !printerInfo.serialNumber">Save</button>

        </div>
    </div>
    <div v-if="(printerCount === 0 || printerCount === 1) && checkBrowserSupport" 
        class='container-add-printer'>
        <!-- <button v-if="printerCount === 0" @click="connectPrinter">
            <img src="../assets/img/PrinterAdd.svg" alt="Add Printer">
            <div class="label-detail action">Add Printer</div>
        </button>    -->
        <div class="setup-options">
            <button class="add-extra action" @click="connectPrinter">Add Printer</button>
                <div><router-link :to="'/help-center/articles/411'">Setup Guide</router-link></div>
        </div>
    </div>
    <div class="message-general">{{ generalMessage }}</div>
</div>
</template>

<script>
export default {
    name: 'ZebraUSBPrinter',
    props: {
        savedPrinterInfo: {
            type: Array,
            required: false 
        },
    },
    data() {
        return {
            allPrinterInfo: [],
            isLoading: false,
            vendorId: 2655,
            currentPrinterInfoIndex: 0,
            generalMessage: '',
            errorMessage: '',
            selectedDuplicatePrinter: '',
            setup: true,
            showToolTipContent: false
        };
    },
    created() {
        this.initPrinters();
        navigator.usb.addEventListener('connect', this.handleConnect);
        navigator.usb.addEventListener('disconnect', this.handleDisconnect);
    },
    destroyed() {
        navigator.usb.removeEventListener('connect', this.handleConnect);
        navigator.usb.removeEventListener('disconnect', this.handleDisconnect);
        this.disconnectAllPrinters();
    },
    mounted() {
        this.initPrinters();
    },
    computed: {
        checkBrowserSupport() {
            if ('usb' in navigator && window.location.protocol === 'https:') {
                // console.log('Component API is supported on this browser.');
                return true;
            } else {
                this.generalMessage = "This print program requires an API that is not supported by your browser. Please update to the latest version of Google Chrome and ensure you are using a secure HTTPS connection";
                return false;
            }
        },
        duplicateTagTypes() {
            const allConnected = this.allPrinterInfo.every(printer => {
                return printer.connected === true
            });
            const tagType = this.allPrinterInfo[0].tagType;
            const identicalLabels = this.allPrinterInfo.every(printer => {
                return printer.tagType === tagType && tagType !== ""
            });
            
            if (this.printerCount > 1 && allConnected && identicalLabels) {
                return true;
            } 
            return false;
        },
        printerCount() {
            return this.allPrinterInfo.length;
        },
    },
    methods: {
        async calibratePrinter(printerInfo) {
            const encoder = new TextEncoder();
            let calibrationCode = '';
            // Change if large tags are ever changed
            if (printerInfo.tagType === 'box' || printerInfo.tagType === 'sequence' || printerInfo.tagType === 'gun' || printerInfo.tagType === 'large') {
                // MNA autodetects type of media (black mark, gap/notch); numbers are label sizes (in dpi)
                // https://docs.zebra.com/us/en/printers/software/zpl-pg/zpl-commands/%5Emn.html
                calibrationCode = '^XA\n^PW449\n^LL733\n^MNA\n~JC\n^XZ';
            } else if (printerInfo.tagType === 'shelf' || printerInfo.tagType === 'sequence_small') {
                calibrationCode = '^XA\n^PW449\n^LL331\n^MNA\n~JC\n^XZ';
            } else if (printerInfo.tagType === 'shelf_wide') {
                calibrationCode = '^XA\n^PW449\n^LL477\n^MNA\n~JC\n^XZ';
            } else if (printerInfo.tagType === 'zebra_4x6') {
                calibrationCode = '! U1 setvar "media.type" "label"\r\n' +
                                  '! U1 setvar "media.sense_mode" "gap"\r\n' +
                                  '~JA\r\n' +
                                  '~JC\r\n' +
                                  '^XA^JUS^XZ\r\n';
            }else {
                this.generalMessage = 'Unknown tag type, exiting calibration method.';
                return;
            }
            const data = encoder.encode(calibrationCode);

            try {
                const printerConnection = await this.getPrinter(printerInfo.serialNumber);
                await this.openPrinter(printerConnection, printerInfo);
                await new Promise(resolve => setTimeout(resolve, 250));
                const res = await printerConnection.transferOut(printerInfo.endpointOut, data);
                // console.log(res)
                if (res.status === 'ok') {
                    this.generalMessage = `Success: Printer has autodetected the type of media and been calibrated for "${printerInfo.tagType}" tags."` 
                } 
            } catch (error) {
                this.generalMessage = 'Error: Calibrating tag problem';
            }
        },
        // Connect method for unassociated printers. Prompts brower device window.
        async connectPrinter() {
            try {
                let printerDevice = null;
                let newPrinterInfo = null;
                printerDevice = await navigator.usb.requestDevice({ filters: [{ vendorId: this.vendorId }] });

                // Prevents overwrite of existing printer
                const existingPrinter = this.allPrinterInfo.find(printer => printer.serialNumber === printerDevice.serialNumber);
                if (existingPrinter) {
                    this.updatePrinter(existingPrinter, true);
                    return;
                }
                // Set and update connection
                await this.setPrinter(printerDevice);
                newPrinterInfo = this.getPrinterInfo(printerDevice.serialNumber);
                await this.openPrinter(printerDevice, newPrinterInfo);
            } catch(error) {
                this.generalMessage = error;
                setTimeout(() => {
                    this.generalMessage = '';
                }, 5000)
            }
        },
        // Close devices when component is not used
        async disconnectAllPrinters() {
            if (this.printerCount > 0) {
                for (const printer of this.allPrinterInfo) {
                    if (printer.connected) {
                        const device = await this.getPrinter(printer.serialNumber);
                        console.log('USB device connection closed.');
                        await device.close();
                    }
                }
            }
        },
        async disconnectPrinter(printerIndex) {
            this.allPrinterInfo.splice(printerIndex, 1);
            if (this.printerCount === 0) {
                this.setup = true;
                // Reset and send to TagPrint
                this.resetInitPrinter();
                this.$emit('save-usb-printer-info', {printers: []});
            } else {
                this.savePrinter(this.allPrinterInfo[0]);
            }
        },
        async getPrinter(serialNumber) {
            try {
                const printers = await navigator.usb.getDevices();
                const foundPrinter = printers.filter(printer => printer.serialNumber === serialNumber);
                return foundPrinter[0]; 
            } catch (error) {
                console.error('Error finding printer:', error);
            }
        },
        // Device settings may be different for Zebra models. Function dynamically queries printer and sets properties
        async getDeviceSettings(printerInfo) {
            try {
                const printerDevice = await this.getPrinter(printerInfo.serialNumber);
                const printerDeviceData = {
                    configuration: this.getConfig(printerDevice),
                    interface: this.getInterface(printerDevice),
                    endpointIn: this.getEndpoint('in', printerDevice),
                    endpointOut: this.getEndpoint('out', printerDevice),
                    packetSize: this.getPacketSize(printerDevice)
                }
                return printerDeviceData;
    
            } catch {
                console.log('Error finding printer.')
            }
        },
        async handleInfoClick(printerInfo, action) {
            this.isLoading = true;
            // Add delay for printer info clicks
            await new Promise((resolve) => {
                setTimeout(async () => {
                await this.printerCheck(printerInfo, action);
                resolve();
            }, 1000);
        });
            this.isLoading = false;
        },
        async handleConnect(event) {
            const deviceIndex = this.allPrinterInfo.findIndex(printer => {
                return printer.serialNumber === event.device.serialNumber;
            });
            // Update printer connection to TagPrint
            if (deviceIndex !== -1 && this.allPrinterInfo[deviceIndex].connected === false) {
                await this.initConnect(this.allPrinterInfo[deviceIndex])
                this.$emit('update-usb-printer-status', this.allPrinterInfo, true);
            }
        },
        // Connection for saved printers
        async initConnect(savedPrinterInfo) {
            try {
                const printerDevice = await this.getPrinter(savedPrinterInfo.serialNumber);
                await this.setPrinter(savedPrinterInfo);
                const newPrinterInfo = this.getPrinterInfo(savedPrinterInfo.serialNumber);
                await this.openPrinter(printerDevice, newPrinterInfo);
            } catch {
                // Not connected printer info, but retain data
                await this.setPrinter(savedPrinterInfo);
            }
        },
        // Check valid saved data and update parent
        async initPrinters() {
            if (Array.isArray(this.savedPrinterInfo) && this.savedPrinterInfo.length > 0) {
                this.setup = false;
                this.allPrinterInfo = this.savedPrinterInfo.map(printerInfo => {
                    return { ...printerInfo };
                });
                
                for (const printerInfo of this.allPrinterInfo) {
                    await this.initConnect(printerInfo);
                }
                this.$emit('update-usb-printer-status', this.allPrinterInfo);
            }
        },
        async findPrinters() {
            try {
                const printerDevices = await navigator.usb.requestDevice({ filters: [{ vendorId: this.vendorId }] });
                // array
                return printerDevices;
            } catch (error) {
                console.error('Error finding printers: ', error);
            }
        },
        // Set printer object abstraction. Device data, status, and printer details
        async setPrinter(printerInfo) {
            const deviceSettings = await this.getDeviceSettings(printerInfo);
            let newPrinter = {
                name: printerInfo.name ? printerInfo.name : '', 
                productName: printerInfo.productName,
                serialNumber: printerInfo.serialNumber,
                tagType: printerInfo.tagType ? printerInfo.tagType : '', 
                connected: false,
                error: false,
                message : '',
                showConfigureModal: false,
                showInfoModal: false,
                ...deviceSettings
            };

            // Find existing printer and update if needed
            const index = this.allPrinterInfo.findIndex(existingPrinter => existingPrinter.serialNumber === printerInfo.serialNumber);
            if (index === -1) {
                // Add new printer
                this.$set(this.allPrinterInfo, this.allPrinterInfo.length, newPrinter);
                this.setup = false;
            } else {
                // Update printer
                Object.keys(newPrinter).forEach(key => {
                this.$set(this.allPrinterInfo[index], key, newPrinter[key]);
                });
            }
        },
        async openPrinter(printer, printerInfo) {
            try {
                // WebUSB api methods
                await printer.open();
                try {
                    await printer.selectConfiguration(printerInfo.configuration);
                    try {
                        await printer.claimInterface(printerInfo.interface);
                        printerInfo.message = printerInfo.tagType ? 'Success: Printer connected.' : 'Success: Printer connected, but not configured.';
                        printerInfo.connected = true;
                    } catch(error) {
                        printerInfo.connected = false;
                        // Multiple tabs can't open the same printer
                        printerInfo.message = 'Error: Printer has been claimed, close extra browser tab(s) or software.';
                    }
                } catch(error) {
                    printerInfo.connected = false;
                    printerInfo.message = 'Error: Printer configuration error.';
                } 
            } catch(error) {
                printerInfo.connected = false;
                printerInfo.message = 'Error: Unable to connect to printer.';
            }
        },
        async printerCheck(printerInfo, command) {
            try {
                const connectedPrinter = await this.getPrinter(printerInfo.serialNumber);
                await this.openPrinter(connectedPrinter, printerInfo);
                const encoder = new TextEncoder();
                const decoder = new TextDecoder();

                // Commands for Zebra printer status. Reference ZPL II manual
                let data = null;
                if (command === 'status') {
                    data = encoder.encode('~HQES\r\n');
                } else if (command === 'config') {
                    data = encoder.encode('^XA^HH^XZ\r\n');
                } else if (command === 'info') {
                    data = encoder.encode('~HI\r\n');
                } else if (command === 'clear') {
                    data = encoder.encode('~JA\r\n');
                } else if (command === 'network') {
                    data = encoder.encode('! U1 getvar "ip.addr"\r\n');
                }
                await connectedPrinter.transferOut(printerInfo.endpointOut, data);

                let completeResponse = '';
                let reading = true;

                // Accomodate older printers by packetSize capacity 
                if (command !== 'clear') {
                    while (reading) {
                        let response = await connectedPrinter.transferIn(printerInfo.endpointIn, printerInfo.packetSize);
                        if (response.status === 'ok') {
                            let responseText = decoder.decode(response.data);
                            completeResponse += responseText;
                        } else {
                            reading = false;
                        }
                        if (response.data.byteLength < printerInfo.packetSize) {
                            reading = false;
                        }
                    }
                }
                if (command === 'status') {
                    this.parseStatusResponse(printerInfo, completeResponse);
                } else if (command === 'network') {
                    if (completeResponse.includes("?")) {
                        printerInfo.message = 'No address found.'
                    } else {
                        printerInfo.message = completeResponse;
                    }
                } else {
                    printerInfo.message = completeResponse;
                } 
            } catch (error) {
                printerInfo.message = 'Error: Unable to send/receive data to printer.';
            }
        },
        async printTag(printData, tagType) {
            const encoder = new TextEncoder();
            const data = encoder.encode(printData);
            try {
                const foundPrinterInfo = this.getLabelPrinter(tagType);  
                if (!foundPrinterInfo) {
                    if (this.printerCount > 0) {
                        this.generalMessage = `Error: Print failed, check printer or label type.`;
                    }
                    return;
                }

                const printer = await this.getPrinter(foundPrinterInfo.serialNumber); 
                await this.openPrinter(printer, foundPrinterInfo);
                const res = await printer.transferOut(foundPrinterInfo.endpointOut, data);

                if (res.status === "ok") {
                    foundPrinterInfo.message = `Success: Label sent to printer.`;
                }
            } catch {
                if (this.printerCount > 0) {
                    this.generalMessage = 'Error: Print failed.';
                }
            }
        },
        // Case where printer is not connected or user updates printer in existing printer card
        async updatePrinter(oldPrinterInfo, skipPrompt=false) {
            try {
                let newPrinter = null;

                if (skipPrompt) {
                    newPrinter = oldPrinterInfo;
                } else {
                    newPrinter = await navigator.usb.requestDevice({ filters: [{ vendorId: this.vendorId }] });
                }
                const printerInfo = this.allPrinterInfo.find(printerInfo => printerInfo.serialNumber === oldPrinterInfo.serialNumber);
                const existingConfig = this.allPrinterInfo.some(existingPrinter => existingPrinter.serialNumber === newPrinter.serialNumber);
                // Update existing config - set printer
                if (!existingConfig) {
                    const deviceSettings = await this.getDeviceSettings(newPrinter);
                    this.$set(printerInfo, 'name', newPrinter.name ? newPrinter.name : '');
                    this.$set(printerInfo, 'productName', newPrinter.productName);
                    this.$set(printerInfo, 'serialNumber', newPrinter.serialNumber);
                    this.$set(printerInfo, 'connected', true);
                    this.$set(printerInfo, 'error', false);
                    this.$set(printerInfo, 'tagType', '');
                    this.$set(printerInfo, 'message', '');
                    this.$set(printerInfo, 'showConfigureModal', false);
                    this.$set(printerInfo, 'showInfoModal', false);

                    for (const key in deviceSettings) {
                        if (deviceSettings.hasOwnProperty(key)) {
                            this.$set(printerInfo, key, deviceSettings[key]);
                        }
                    }
                    printerInfo.message = printerInfo.tagType ? 'Success: Printer connected.' : 'Success: Printer connected, but not configured.'
                } else {
                    if (printerInfo && oldPrinterInfo.serialNumber === printerInfo.serialNumber) {
                        await this.initConnect(printerInfo);
                        this.$emit('update-usb-printer-status', this.allPrinterInfo, true);
                    }
                    else {
                        printerInfo.message = 'Error: Duplicate printer, printer already added.'
                    }
                }
            } catch (error) {
                console.log('Error: update failed.')
            }
        },
        resetPrinter(printer) {
            printer.name = ''; 
            printer.productName = '';
            printer.serialNumber = '';
            printer.tagType = '';
            printer.configuration = null;
            printer.interface = null;
            printer.endpointIn = null;
            printer.error = false;
            printer.endpointOut = null;
            printer.packetSize = 0;
            printer.connected = false;
            printer.showConfigureModal = false;
            printer.showInfoModal = false;
            this.$emit('update-usb-printer-status', this.allPrinterInfo, true);
            printer.message = 'Info has been reset.'

        },
        async savePrinter(printerInfo) {
            // Create object to store savedPrinters and validate existing printer configs for saving
            const savePrinters = this.allPrinterInfo
                .filter(printer => this.validatePrinterConfig(printer))
                .map(printer => JSON.parse(JSON.stringify(printer)));

            const passedValidation = savePrinters.some(printer => {
                return printer.serialNumber === printerInfo.serialNumber; 
            });
            
            // Failed, refactor
            if (!passedValidation) {
                return;
            }

            if (passedValidation) {
                printerInfo.message = "Success: Printer saved.";
            } else {
                // Check if empty or check tag type
                if (!printerInfo.tagType) {
                    printerInfo.message = "Error: Unable to save, no tag type.";
                } else {
                    printerInfo.message = "Error: Unable to save, bad/missing data."; 
                }
            }

            // Strip status properties of all printers
            // Maybe we should save some?
            savePrinters.forEach(printer => {
                delete printer.connected;
                delete printer.error;
                delete printer.configuration;
                delete printer.interface;
                delete printer.endpointIn;
                delete printer.endpointOut;
                delete printer.message;
                delete printer.showConfigureModal;
                delete printer.showInfoModal;
                delete printer.packetSize;
            })
            this.$emit('save-usb-printer-info', {printers: savePrinters});
            printerInfo.showConfigureModal = false
        },
        badPrinterName(printer) {
            const maxLength = 12;
            const regex = /^[a-zA-Z0-9\s\-\_\.\'\(\)\+\&]+$/;

            if (printer.name.length === 0) {
                this.errorMessage = '' 
                return false 
            } else if (printer.name.length > maxLength) {
                this.errorMessage = 'Error: Name too long.' 
                return true 
            } else if (!regex.test(printer.name)) {
                this.errorMessage = 'Error: Bad character/letter, please remove.' 
                return true;
            } else {
                this.errorMessage = '' 
                return false;
            }
        },
        // Used for status report
        checkError(index, char, messages, reportList) {
            if (messages[index] && messages[index][char]) {
                reportList.push(messages[index][char]);
            }
        },
        getPrinterInfoName(printer) {
            return printer.name ? printer.name  : printer.productName.slice(3,9) 
        },
        getLabelPrinter(type) {
            // NOTE: Need to change if one of these tags ever changes dimensions
            const largeTags = ['box', 'sequence', 'gun'];
            const fourBySixTags = ['zebra_4x6'];

            // Find printer by specific tag type
            let foundPrinter = this.allPrinterInfo.find(printer => {
                if (this.duplicateTagTypes) {
                    if (printer.connected && !this.selectedDuplicatePrinter) {
                        return printer;
                    }
                    return ((printer.connected) && (printer.tagType === type) && (printer.serialNumber === this.selectedDuplicatePrinter))
                } else {
                    return printer.connected && printer.tagType === type;
                }
            });
            // Find "large" associated printer
            if (!foundPrinter) {
                const largeTagPrinter = this.allPrinterInfo.find(printer => {
                    if (this.duplicateTagTypes) {
                        return (printer.connected && printer.tagType === 'large' && largeTags.includes(type) && (printer.serialNumber === this.selectedDuplicatePrinter))
                    }
                    return printer.connected && printer.tagType === 'large' && largeTags.includes(type)
                })
                foundPrinter = largeTagPrinter;
            }   

            // Otherwise, find any large tag printer to print since labels are the same.
            if (!foundPrinter && largeTags.includes(type)) {
                const anyLargeTagPrinter = this.allPrinterInfo.find(printer => {
                    return printer.connected && largeTags.includes(printer.tagType)
                })
                foundPrinter = anyLargeTagPrinter;
            }

            // Don't fallback to other printers for a 4x6 tag
            if(!foundPrinter && fourBySixTags.includes(type)) {
                return null;
            }
            return foundPrinter;
        },
        // Used for status report
        generateReport(code, type, messages) {
            const report = {
                status: '',
                errors: [],
                warnings: []
            };

            if (code[0] === '0') {
                report.status = `No ${type.toLowerCase()}s: ` + code;
            } else {
                report.status = `${type}(s) found: ${code}`;
                const reportType = type.toLowerCase() === 'error' ? 'errors' : 'warnings';

                for (let i = 12; i <= 16; i++) {
                    this.checkError(i, code[i], messages, report[reportType]);
                }
            }
            return report;
        },
        handleConfigureModal(printerInfo) {
            printerInfo.showConfigureModal = !printerInfo.showConfigureModal;
            if (this.badPrinterName(printerInfo)) {
                printerInfo.name = '';
            }
            this.generalMessage = '';
            this.errorMessage = '';
            printerInfo.message = '';
        },
        handleDisconnect(event) {
                const deviceIndex = this.allPrinterInfo.findIndex(printer => {
                return printer.serialNumber === event.device.serialNumber;
                });
            if (deviceIndex !== -1) {
                this.allPrinterInfo[deviceIndex].connected = false;
                this.allPrinterInfo[deviceIndex].message = 'Printer disconnected.'
                this.$emit('update-usb-printer-status', this.allPrinterInfo, true);
            }
        },
        handleStatusModal(printerInfo) {
            printerInfo.showInfoModal = !printerInfo.showInfoModal;
            printerInfo.message = '';
        },
        // Used for status report
        formatResponse(printer, errorResponse, warningResponse) {
            // Format
            let response = 'PRINTER CHECK \n';
            response += "===============\n\n"
            if (warningResponse.warnings.length === 0 && errorResponse.errors.length === 0) {
                response += 'Printer is healthy.\n\n'
            } else {
                response += 'See response.\n\n'
            }

            response += errorResponse.status + "\n\n";
            if (errorResponse.errors.length > 0) {
                printer.printerError = true;
                errorResponse.errors.forEach((error, index) => {
                    response += 'Error[' + `${index+1}` + ']: ' + error + '\n';  
                })
                response += '\n'; 
            }
            response += warningResponse.status + "\n\n";
            if (warningResponse.warnings.length > 0) {
                warningResponse.warnings.forEach((warning, index) => {
                    response += 'Warning[' + `${index+1}` + ']: ' + warning + '\n';  
                })
            }
            return response;
        },
        getPrinterInfo(serialNumber) {
            const printerInfo = this.allPrinterInfo.find(existingPrinter => existingPrinter.serialNumber === serialNumber);
            return printerInfo;
        },
        getConfig(printerDevice) {
            const deviceConfigs = printerDevice.configurations;
            if (deviceConfigs.length === 0) {
                throw new Error('No configurations found');
            }
            const deviceConfig = deviceConfigs[0];
            return deviceConfig.configurationValue;
        },
        getInterface(printerDevice) {
            const deviceInterfaces = printerDevice.configurations[0].interfaces;
            if (deviceInterfaces.length === 0) {
                throw new Error('No interfaces found');
            }
            let deviceInterfaceValue = [];
            for (const iface of deviceInterfaces) {
                deviceInterfaceValue.push(iface.interfaceNumber);
            }
            return deviceInterfaceValue[0];
        },
        getEndpoint(endpointType, printerDevice) {
            const interfaceValue = this.getInterface(printerDevice);
            const deviceInterface = printerDevice.configurations[0].interfaces[interfaceValue].alternates[0];
            let endpointValue = null;
            deviceInterface.endpoints.forEach(endpoint => {
                if (endpoint.direction === endpointType) {
                    endpointValue = endpoint.endpointNumber;
                }
            })
            return endpointValue;
        },
        getPacketSize(printerDevice) {
            const interfaceValue = this.getInterface(printerDevice);
            const deviceInterface = printerDevice.configurations[0].interfaces[interfaceValue].alternates[0];
            let packetSize = null;
            deviceInterface.endpoints.forEach(endpoint => {
                packetSize = endpoint.packetSize
            })
            return packetSize;
        },
        printerNameLabel(productName, name) {
            if (productName && name) {
                return productName.slice(3,9) + ': ' + name;
            }
            return ''; 
        },
        resetInitPrinter() {
            this.allPrinterInfo = [
            ]
        },
        sendMessage(message) {
            // Don't overwrite browser incompatibility message
            if (this.checkBrowserSupport) {
                this.generalMessage = message;
                setTimeout(() => {
                    this.generalMessage = '';
                }, 5000);
            }
        },
        // Method used to parse error/warning code response from Zebra
        parseStatusResponse(printer, responseText) {
            const lines = responseText.trim().split('\n');
            let error = '';
            let warning = '';
            const errorsRegex = /ERRORS:\s*(\d+)\s*([\d\s]+)/;
            const warningsRegex = /WARNINGS:\s*(\d+)\s*([\d\s]+)/;

            lines.forEach(line => {
                const errorsMatch = line.match(errorsRegex);
                const warningsMatch = line.match(warningsRegex);

                if (errorsMatch) {
                    // Parse strings, refactor
                    error = errorsMatch.slice(1).join(' ').trim();
                    error = error.replace(/\s/g, "");
                } else if (warningsMatch) {
                    warning = warningsMatch.slice(1).join(' ').trim();
                    warning = warning.replace(/\s/g, "");
                }
            });     
            const errorResponse = this.zebraErrors(error);
            const warningResponse = this.zebraWarnings(warning);
            const response = this.formatResponse(printer, errorResponse, warningResponse)
            printer.message = response;
        },
        validateTagType(printerInfo) {
            if (!printerInfo.tagType) {
                printerInfo.message = "Tag type required. Printer will not save.";
                return false;
            } else {
                printerInfo.message = '';
                return true;
            }
        },
        validatePrinterConfig(printer) {
            // Check for name error
            if (this.badPrinterName(printer)) {
                return false;
            }

            // Check if all fields are empty
            if (!printer.tagType && !printer.serialNumber && !printer.productName && !printer.name) {
                return false;
            }

            // Check for missing tag type
            if (!this.validateTagType(printer)) {
                return false;
            }

            // Check for missing serial number or product name
            if (!printer.serialNumber || !printer.productName) {
                return false;
            }
            return true;
        },
        // Documentation is sparse and some of these error/warning codes may not be applicable to every Zebra model; however,
        // the primary errors have been tested and confirmed (pause, open head, cutter fault)
        zebraErrors(errorCode) {    
            // Key is special nibble value. Key within key is error and value is error message.
            const errorMessages = {
                12: {
                    '1': 'Printer is paused',
                    '2': 'Retract function timed out',
                    '4': 'Black mark calibrate error',
                    '8': 'Black mark not found'
                },
                13: {
                    '1': 'Paper jam during retract',
                    '2': 'Presenter not running',
                    '4': 'Paper feed error',
                    '8': 'Clear paper path failed'
                },
                14: {
                    '1': 'Invalid firmware config',
                    '2': 'Printhead thermistor open'
                },
                15: {
                    '1': 'Printhead over temperature',
                    '2': 'Motor over temperature',
                    '4': 'Bad printhead element',
                    '8': 'Printhead detection error'
                },
                16: {
                    '1': 'Label media is out',
                    '2': 'Ribbon out',
                    '4': 'Printer head is open',
                    '8': 'Cutter fault'
                }
            };
            return this.generateReport(errorCode, 'Error', errorMessages);
        },
        zebraWarnings(warningCode) {
            // Key is special Zebra nibble value.
            const warningMessages = {
                16: {
                    '1': 'Need to calibrate media',
                    '2': 'Clean printhead',
                    '4': 'Replace printhead',
                    '8': 'Paper-near end'
                }
            };
            return this.generateReport(warningCode, 'Warning', warningMessages);
        },
    }
};
</script>
    
<style scoped>

.container-printer {
    display: grid;
    grid-template-columns: 2.25fr 4fr .75fr;
    width: clamp(600px, 80%, 1200px);
    height: clamp(90px, 8vh, 120px);
    border: 2px solid lightgray;
    column-gap: .25rem;
    /* margin: 0 auto;  */
    margin-bottom: 0.5vh;
}
.container-printer:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    height: clamp(92.5px, 8.25vh, 122.5px);
    border: 2px solid darkgrey;
}

.container-add-printer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.setup-options {
    display: flex;
    justify-content: center;
    align-items: center;
    /* flex-direction: column; */
    gap: .25vh;
}
.setup-options div {
    color: black; 
    text-decoration: underline; 
    cursor: pointer; 
}

.col-1, .col-2, .col-3 {
    overflow: hidden;
}

.col-1 {
    height: 100%;
    width: 100%;
}

.specs {
    display: flex;
    justify-content: center;
    align-items: center; 
    overflow: hidden; 
    height: 100%;
    width: 100%;
}

.image-status {
    flex: 0 0 35%; 
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    height: 100%; 
}
.image-status button {
    padding: 0px;
    height: 100%;
    width: 100%;
    background-color: white;
}
.image-status img {
    height: clamp(50px, 80%, 120px);
    width: clamp(50px, 80%, 120px);
    object-fit: contain; 
    background-color: white;
}

.text-specs {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: wrap; 
    margin-left: 8px;
    width: 100%;
    height: 100%;
}
.text-specs h3,
.text-specs #special-p {
    text-decoration: none;
    margin: 0; 
    padding: 0;
    width: 100%;
    color: black;
}
.text-specs p {
    font-size: clamp(6px, calc(6px + .4vw), 16px);
    letter-spacing: .1em;
}

.text-specs h3 {
    font-size: clamp(10px, calc(6px + .6vw), 20px);
}

.col-2 {
    display: grid;
    grid-template-rows: 80% 20%;
    justify-items: center;
    width: 100%;
}

.options-row {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.options-row button {
    display: flex;
    justify-content: center;
    padding: 8px 20px;
    color: white;
    font-size: clamp(8px, .7rem, 1.2rem);
    height: clamp(2rem, 20%, 4rem);;
    width: clamp(6rem, calc(25px + 7.5vw), 12.5rem);
    cursor: pointer;
    margin-top: 20px;
}

.status-message {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    align-self: end;
    width: 100%;
    font-size: 16px;
    color: #333;
}
.status-message #special-p {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    font-size: clamp(12px, calc(6px + .5vw), 16px);
    color: #333;
    margin: 0px;
    margin-bottom: .1rem;
}

.col-3 {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    min-width: 60px;
}

.col-3 button {
    padding: 0.75em 1.3em;
    font-size: clamp(8px, .65rem, 24px );
    margin: 0;
    align-self: flex-end;
    height: auto;
}
.col-3 #delete {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    align-self: flex-end;
    /* font-size: .7em; */
    font-size: clamp(8px, .65rem, 24px );
    height: 20px;
    width: 20px;
    background-color: darkgray;
}

.col-3 .save {
    width: 80%;
}
.add-extra {
    margin: 10px;
}

.message-general {
    display: flex;
    justify-content: center;
    margin-top: 5px;
    align-items: center;
}

/* Modal */
.modal .inner {
    height: clamp(30vh, 20em, 35vh); /* 50% */
    width: 40%;
}

.calibrate-buttons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}
.calibrate-buttons > * {
    margin: 0;
}
.config-message {
    margin: 1rem;
    margin-top: 0;
    font-size: clamp(12px, calc(8px + .5vw), 16px);
}
button:disabled {
    background-color: darkgray; 
    cursor: not-allowed;
}
.content {
    height: 80%;
    background-color: white;
}

.printer-info {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: white;
    width: 100%;
    height: 100%;
    gap: 1rem;
}
.printer-info .action {
    margin-top: 0;
    height: clamp(30px, 4.5vh, 40px);
    width: clamp(100px, 9vw, 180px);
    font-size: clamp(8px, .7rem, 1.2rem);
    /* font-size: .65rem; */
}
#diagnostic-output {
    height: 70%;
    width: 100%;
    min-width: 250px;
    pointer-events: scroll;
    padding-top: 0;
    margin-bottom: 0;
}
.info-options-col-2 {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
}
.info-options-col-2 h4 {
    margin: 0;
    width: 100%;
    text-align: center;
    font-size: 1.25rem;
    color: #666;
    background-color: white;
}
.info-options-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 30%;
    gap: 1rem; 
}
.info-options-row {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 1rem;
    gap: 1rem;
}
.container-info {
    display: flex;
    justify-content: center;
    align-content: center;
    gap: .25rem;
    margin: 1rem;
}
.container-info button {
    margin-top: 0;
}
.container-info .tool-tip {
    display: flex;
    justify-content: center;
    align-items: center;
}
.controls .button {
    margin-top: 0;
}
/* Tool Tip */
.tool-tip-content {
    z-index: 1000;
    position: absolute;
    background-color: white;
    border: 1px solid #aaa !important;
    box-shadow: 0 0 3px 1px #e4e4e4;
    color: #000000;
    font-size: 0.85em;
    bottom: 5rem; 
    left: 70%;
    font-family: Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    text-transform: none;
    padding: .5rem;
}
.tool-tip-right {
    left: 55%;
}
</style> 
    
